module.exports = __webpack_public_path__ + "static/media/error.6d05c5eb.svg";